import React from 'react';

const Search = (props) => (
  <div className="search">
    <div className="search__bar">
      <input
        className="search__input"
        type="search"
        placeholder="Search..."
        onChange={props.handleInputChange}
        value={props.searchValue}
      />
      <div className="search__icon" />
    </div>
  </div>
);

export default Search;
